import React, { RefObject } from 'react';
import { RestaurantDetails_getRestaurantDetails } from '../../../../../types/graphql-types-generated.ts';
import { RestaurantMetaInfoSummary } from '../../00-atoms/restaurant-meta-info-summary/restaurant-meta-info-summary.tsx';
import { ModalRef } from '../../../../../patterns/01-molecules/modal/modal.tsx';
import { Paths } from '../../../../../utils/paths.ts';
import { RestaurantMemebership } from '../../02-organisms/restaurant-info-modal/membership.tsx';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type RestaurantMetaInfoProps = {
  restaurantDetails: RestaurantDetails_getRestaurantDetails;
  modalRef: RefObject<ModalRef | null>;
  setShowStickyAd?: (show: boolean) => void;
};

export const RestaurantMetaInfo: React.FunctionComponent<RestaurantMetaInfoProps> = props => {
  const { restaurantDetails } = props;

  return (
    <div className="text-sk-dark-blue flex flex-col bg-white p-4">
      <a
        href={Paths.cityListing(restaurantDetails.linkedCity.fullnameLower)}
        className="text-sk-link-red flex justify-center text-sm md:justify-start"
        onClick={() => UBTracking.trackEvent.click('restaurant_header', 'BREADCRUMB_CITY')}
      >
        Restaurants in {restaurantDetails.linkedCity.name}
      </a>
      <h1 className="mt-1 flex items-center justify-center text-2xl/10 font-extrabold md:justify-start md:text-3xl/8">
        <span>{restaurantDetails.name}</span>
        <RestaurantMemebership membershipType={restaurantDetails.membershipType} />
      </h1>
      <div className="md:flex">
        <div className="flex justify-center md:mt-1 md:justify-start">
          <RestaurantMetaInfoSummary restaurantDetails={restaurantDetails} cuisineLinking={true} />
        </div>
        <div className="mt-1 flex justify-center md:mt-0 md:ml-2">
          <button
            onClick={() => {
              UBTracking.trackEvent.click('restaurant_header', 'RESTAURANT_INFO_MODAL_OPEN');
              props.setShowStickyAd && props.setShowStickyAd(true);
              props.modalRef.current?.openModal();
            }}
            className="text-sk-link-red mt-1 flex justify-center text-sm"
          >
            Mehr Infos
          </button>
        </div>
      </div>
    </div>
  );
};
